// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OptInMutationVariables = Types.Exact<{
  page: Types.Scalars['String']['input'];
  section: Types.Scalars['String']['input'];
  site: Types.Scalars['String']['input'];
  language?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type OptInMutation = { __typename?: 'Mutation', contentOptIn?: { __typename?: 'ContentOptInPayload', success?: boolean, participating?: boolean, errors?: Array<{ __typename?: 'ContentError', message?: string, code?: number, params?: Array<{ __typename?: 'ContentErrorParam', name?: string, value?: string }> }>, content?: { __typename?: 'Content', id: string, pages?: { __typename?: 'ContentPageConnection', edges?: Array<{ __typename?: 'ContentPageEdge', node?: { __typename?: 'ContentPage', id: string, participating?: boolean } }> }, myParticipations?: { __typename?: 'ContentPageConnection', totalCount?: number, edges?: Array<{ __typename?: 'ContentPageEdge', node?: { __typename?: 'ContentPage', id: string, name?: string, summary?: string, mediumImage?: string, largeImage?: string, handle?: string, publishEndDate?: string, participationDate?: string, termsExternal?: string, terms?: string } }> } } } };


export const OptInMutationDocument = /*#__PURE__*/ gql`
    mutation OptInMutation($page: String!, $section: String!, $site: String!, $language: String) {
  contentOptIn(input: {page: $page, section: $section, site: $site}) {
    success
    participating
    errors {
      message
      code
      params {
        name
        value
      }
    }
    content {
      id
      pages(first: 1, filter: {site: $site, handle: $page, section: $section}) {
        edges {
          node {
            id
            participating
          }
        }
      }
      myParticipations(filter: {language: $language, section: $section}) {
        totalCount
        edges {
          node {
            id
            name
            summary
            mediumImage
            largeImage
            handle
            publishEndDate
            participationDate
            termsExternal
            terms
          }
        }
      }
    }
  }
}
    `;
export type OptInMutationMutationFn = Apollo.MutationFunction<OptInMutation, OptInMutationVariables>;
export function useOptInMutation(baseOptions?: Apollo.MutationHookOptions<OptInMutation, OptInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptInMutation, OptInMutationVariables>(OptInMutationDocument, options);
      }
export type OptInMutationHookResult = ReturnType<typeof useOptInMutation>;
export type OptInMutationMutationResult = Apollo.MutationResult<OptInMutation>;
export type OptInMutationMutationOptions = Apollo.BaseMutationOptions<OptInMutation, OptInMutationVariables>;